import {
  DeleteReimbursableTaxonomyMappingDocument,
  DeleteReimbursableTaxonomyMappingMutationVariables,
  ReimbursableSupplementTaxonomiesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useDeleteReimbursableSupplementMapping = () => {
  const [deleteReimbursableSupplementMapping, { loading }] = useMutation(
    DeleteReimbursableTaxonomyMappingDocument,
    {
      extractorFn: (data) => data.payrollMutations.deletePayrollReimbursableSupplementTaxonomy,
      refetchQueries: [ReimbursableSupplementTaxonomiesDocument],
      awaitRefetchQueries: true,
    },
  )

  return {
    loading,
    delete(variables: DeleteReimbursableTaxonomyMappingMutationVariables) {
      return deleteReimbursableSupplementMapping({
        variables,
      })
    },
  }
}

export default useDeleteReimbursableSupplementMapping
